import React, {Component} from 'react';
import { __, __n } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ScoreRow from '../elements/ScoreRow';
import ContentContainer from '../elements/ContentContainer';
import ListButton from '../elements/ListButton';
import Defines from "../../Defines";
import {dispatchUnreadPopup, getPopupCurrentGame} from "../../helpers/popupHelper";

import team from '../../assets/img/icons/economy/team.svg';
import PopUp from "../elements/PopUp";
import apiCall from '../apiCall';
import { getGroupAvatarUrl } from '../../helpers/groupHelper';

class GroupPortalHome extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      schoolRank: '-',
      schoolClassRank: '-',
      totalPoints: '-',
      showPopUp: false,
    };
    this.togglePopup = this.togglePopup.bind(this);
  };

  componentWillMount() {
    this.fetchMyRank();
    window.socket.on('finishedSimulationStep', this.fetchMyRank);
    window.socket.on('activate', this.fetchMyRank);
  }

  componentDidMount(){
    const { dispatch, project, gameState } = this.props;
    const currentRound = (gameState.Rounds ? gameState.Rounds.length - 1 : 1);
    if (project.EducationProject.nameShort === 'GLXL' && currentRound <= 1) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtintro_welkom' : 'mlgvtintro_welkom'), dispatch);
    }
  }

  fetchMyRank = async () => {
    apiCall('/group/myRank', null, 'GET')
      .then(({ schoolClassRank, schoolRank, totalPoints }) => {
        this.setState({
          schoolClassRank,
          schoolRank,
          totalPoints,
        });
      });
  };

  togglePopup = () => {
    this.setState({
      showPopUp: !this.state.showPopUp
    })
  }

  /**
   * Render game buttons using redux state data
   */
  renderGameButtons = () => {
    const { schoolClass } = this.props;

    // Get games from my schoolClass
    if (!Array.isArray(schoolClass.SchoolClassGames)) return null;
    const games = schoolClass.SchoolClassGames.reduce((arr, val) => {
      // Ignore Simulationgame as it has a custom button
      if (val.Game.abbreviation !== 'SS' && val.Game.abbreviation !== 'BO') arr.push(val.Game);
      return arr;
    }, []);

    // Render game buttons
    return games.map((g) => {
      const curGame = Defines.gameLogos.find(game => game.id === g.id);
      const hasGamePage = Defines.gamePageGames.findIndex(game => game.id === g.id);
      const hasGamePageContent = getPopupCurrentGame(g.abbreviation) !== false;
      return (
        <ListButton
          key={g.id}
          title={__(g.name)}
          subtitle={`${this.props.project.EducationProject.nameShort === 'GLXL' ? __('sim_globas_verdienen') : ''}`}
          icon={curGame.logo}
          className={'gameButton opacity'}
          onClick={() => {
            if (hasGamePage > -1 && hasGamePageContent) {
              return this.props.history.push(`/portal/gameinfo/${g.id}`)
            }
          }}
        />
      );
    });
  };

  render() {
    const bonus = this.props.schoolClass.SchoolClassGames.find(g => g.Game.abbreviation === 'BO');
    const simGame = Defines.gameLogos.find(game => game.abbreviation.toLowerCase() === 'ss');
    const boGame = Defines.gameLogos.find(game => game.abbreviation.toLowerCase() === 'bo');
    const { showPopUp } = this.state;
    return (
      <div className={'portal-home class-portal ' + (this.props.project.EducationProject.nameShort === 'GLXL' ? '' : 'non-glxl')}>
        <div className={'portal-container'}>
          <div className={'container'}>
            {this.props.project.EducationProject.nameShort === 'GLXL' ? (
              <div className={'score-container'}>
                {this.props.gameState.hideScores ? (
                  <ContentContainer className="disabled-scores-container">
                    <p className={'disabled-scores'}>{__('sim_tussenstand_uitgeschakeld')}</p>
                  </ContentContainer>
                ) : (
                  <div>
                    <ScoreRow
                      text={__('sim_puntentotaal')}
                      score={this.state.totalPoints || 0}
                      showArrow={true}
                      to="/portal/teaminfo"
                    />
                    <ScoreRow
                      text={__('sim_ranglijst_school')}
                      score={this.state.schoolRank || 0}
                      showMedal={true}
                      showArrow={true}
                      to={`/portal/rankings/${this.props.group.ProjectId}`}
                    />
                    <ScoreRow
                      text={__('sim_ranglijst_klas')}
                      score={this.state.schoolClassRank || 0}
                      showMedal={true}
                      showArrow={true}
                      to={`/portal/rankings/${this.props.group.ProjectId}/${this.props.group.SchoolClassId}`}
                    />
                  </div>
                )}
              </div>
            ) : null}
            <div className={'list-button-container'}>
              {this.props.project.EducationProject.nameShort === 'GLXL' ? (
                <div>
                  <ListButton
                    title={__('sim_team_info')}
                    subtitle={__('sim_gegevens_en_scores')}
                    icon={getGroupAvatarUrl(this.props.group, this.props.project, team)}
                    className={'gameButton opacity' + this.props.group.Avatar ? ' with-avatar-icon' : ''}
                    onClick={() => {
                      this.props.history.push('/portal/teaminfo');
                    }}
                  />
                  <ListButton
                    title={__('sim_land_besturen')}
                    subtitle={`${__('sim_globas_verdelen')}`}
                    icon={simGame.logo}
                    className={'gameButton opacity'}
                    onClick={() => {
                      if ((!this.props.gameState.simGameActive && this.props.gameState.currentRound <= 4) || this.props.gameStateInput.processingStepThree !== false) {
                        this.togglePopup()
                      } else {
                        window.location.href = this.props.gameState.simGameEntry;
                      }
                    }}
                  />
                </div>
              ) : (
                <div className={'title-container'}>
                  <h3>{__n('sim_spel', 0)}</h3>
                </div>
              ) }
              {this.renderGameButtons()}
              {bonus ?
                <ListButton
                  title={__('sim_extra_opdrachten')}
                  subtitle={__('sim_bonuspunten')}
                  icon={boGame.logo}
                  className={'gameButton opacity'}
                  onClick={() => {
                    this.props.history.push('/portal/bonuspoints');
                  }}
                /> : ''
              }

              { showPopUp ? (
                <PopUp popUpFooter={true} id={['SIMULATION_SPENDING', 'END'].includes(this.props.gameState.roundData.state) ? 'dlgmlandbesturen_1' : 'mlgmlandbesturen'} closePopUpClick={this.togglePopup}/>
              ) : null }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  user: state.user,
  project: state.project,
  group: state.group,
  schoolClass: state.schoolClass,
  gameState: state.gameState,
  feedBack: state.feedBack,
  gameStateInput: state.gameStateInput,
}))(GroupPortalHome);



// WEBPACK FOOTER //
// ./src/components/routes/GroupPortalHome.js